export default __webpack_public_path__ + "static/media/civics-icon.aa1aefab.webp";